const appHostname = (subdomain = 'app') => {
  return `${subdomain}.${__HOSTNAME__}`;
};

export default appHostname;
